{
  "settings.common.pageSize": "Rows per page",
  "settings.common.pageSizeOption": "{count} per page",
  "settings.teams.detail.description": "View team information and manage its members and responsibilities.",
  "settings.teams.editAria": "Edit {name}",
  "settings.teams.toggleActiveAria": "Enable or disable {name}",
  "settings.teams.memberRoleLabel": "Team role",
  "settings.agents.table.name": "Member",
  "settings.agents.detail.description": "View and manage this member’s support profile, access status, and global roles.",
  "settings.teams.editMemberProfileAria": "Edit {name}'s profile",
  "settings.routing.summary.label": "Conditions → assignment",
  "settings.routing.summary.matchAll": "Match all",
  "settings.routing.summary.unrestricted": "Other conditions are unrestricted",
  "settings.routing.summary.project": "Project: {name}",
  "settings.routing.summary.category": "Category: {name}",
  "settings.routing.summary.channel": "Channel: {name}",
  "settings.routing.summary.to": "Assign to",
  "settings.routing.preview.title": "Rule preview",
  "settings.routing.preview.enabled": "Enabled after saving and included in new-ticket routing.",
  "settings.routing.preview.disabled": "Disabled after saving and excluded from new-ticket routing.",
  "settings.routing.preview.scope": "Checks only the {count} loaded rules, not actual ticket matches.",
  "settings.routing.preview.sameCriteria": "Shares basic conditions with rules at priority {priorities}; check their targets and execution order.",
  "settings.routing.preview.samePriority": "Priority {priority} is already used; ties are ordered by rule ID.",
  "settings.routing.preview.categoryCleared": "The category was cleared because it does not belong to the selected project.",
  "settings.routing.preview.projectSelected": "This project team only receives tickets from {project}, so that project was selected automatically.",
  "settings.routing.copy.action": "Create from this rule",
  "settings.routing.copy.title": "Create from existing rule",
  "settings.routing.copy.description": "Copied the conditions and target from priority {sourcePriority}. The new priority is {priority}, and the rule starts disabled. Review it before saving.",
  "settings.common.unsavedChanges": "Unsaved changes",
  "settings.agents.revokeRoleDialog.title": "Revoke {role} from {name}?",
  "settings.agents.revokeRoleDialog.description": "This member will lose the permissions granted by this role. If these are their last permissions, they may lose workspace access.",
  "settings.agents.revokeRoleDialog.confirm": "Revoke role",
  "settings.navigation.ticketing": "Ticket configuration",
  "settings.navigation.operations": "Organization & AI",
  "settings.common.unsaved.title": "Discard unsaved changes?",
  "settings.common.unsaved.description": "You have unsaved changes. Leaving will discard them.",
  "settings.common.unsaved.discard": "Discard and leave",
  "settings.common.unsaved.keepEditing": "Keep editing",
  "settings.common.saving": "Saving…",
  "settings.common.savingDescription": "Wait for the current operation to finish before leaving so you can verify the result.",
  "settings.common.saved": "All changes saved",
  "settings.common.discardChanges": "Cancel changes",
  "settings.common.readOnly": "You have view-only access to these settings.",
  "settings.common.referenceUnavailable": "Some reference data is unavailable. Check your permissions or refresh to retry. Related editing actions are unavailable.",
  "settings.routing.disableDialog.title": "Disable the priority {priority} rule?",
  "settings.routing.disableDialog.description": "New tickets will no longer pass through this routing rule. You can enable it again at any time.",
  "settings.projects.disableDialog.title": "Disable project “{name}”?",
  "settings.projects.disableDialog.description": "This project will no longer receive new tickets. Existing tickets are retained. You can enable it again at any time.",
  "settings.teams.removeMemberDialog.title": "Remove {name} from this team?",
  "settings.teams.removeMemberDialog.description": "Remove {name} from {team}. Their workspace account will remain available.",
  "settings.teams.removeMemberDialog.confirm": "Remove member",
  "settings.common.cancel": "Cancel",
  "settings.common.save": "Save",
  "settings.common.add": "Add",
  "settings.common.edit": "Edit",
  "settings.common.delete": "Delete",
  "settings.common.actions": "Actions",
  "settings.common.refresh": "Refresh",
  "settings.common.retry": "Try again",
  "settings.common.clearFilters": "Clear filters",
  "settings.common.enable": "Enable",
  "settings.common.disable": "Disable",
  "settings.common.notSet": "Not set",
  "settings.common.disabledSuffix": " (disabled)",
  "settings.common.status.label": "Status",
  "settings.common.status.all": "All statuses",
  "settings.common.status.enabled": "Enabled",
  "settings.common.status.disabled": "Disabled",
  "settings.common.middleDotSeparator": " · ",
  "settings.common.listSeparator": "; ",

  "settings.projects.title": "Projects",
  "settings.projects.description": "Manage service projects and their basic settings. Projects are hierarchical, and disabled projects no longer receive new tickets.",
  "settings.projects.new": "New project",
  "settings.projects.create": "Create project",
  "settings.projects.refreshing": "Refreshing projects",
  "settings.projects.loading": "Loading projects…",
  "settings.projects.saving": "Saving project",
  "settings.projects.searchAria": "Search projects",
  "settings.projects.searchPlaceholder": "Search project names or codes…",
  "settings.projects.column.project": "Project",
  "settings.projects.column.code": "Project code",
  "settings.projects.hierarchyContextOnly": "Shown only to provide hierarchy context; this project does not match the current filters",
  "settings.projects.enableAria": "Enable project {name}",
  "settings.projects.disableAria": "Disable project {name}",
  "settings.projects.actionsAria": "Actions for {name}",
  "settings.projects.empty.title": "No projects yet",
  "settings.projects.empty.description": "Create a project so tickets and categories can be organized under it.",
  "settings.projects.empty.filteredTitle": "No matching projects",
  "settings.projects.empty.filteredDescription": "Try changing the search term or status filter.",
  "settings.projects.count.total": "{count} projects total",
  "settings.projects.count.filtered": "{matched} matching projects out of {total}",
  "settings.projects.deleteDialog.title": "Delete project “{name}”?",
  "settings.projects.deleteDialog.description": "This cannot be undone. Its child projects will become top-level projects. If you only need to pause it, use the switch in the list instead.",
  "settings.projects.form.editTitle": "Edit project",
  "settings.projects.form.createTitle": "New project",
  "settings.projects.form.editDescription": "Change the project's code, name, and parent.",
  "settings.projects.form.createDescription": "Projects organize tickets and categories and can be arranged in a hierarchy.",
  "settings.projects.form.codeLabel": "Project code",
  "settings.projects.form.codePlaceholder": "For example, PAY-CORE",
  "settings.projects.form.codeDescription": "Globally unique and used in ticket numbers and external API references.",
  "settings.projects.form.nameLabel": "Project name",
  "settings.projects.form.namePlaceholder": "For example, Payments Platform",
  "settings.projects.form.parentLabel": "Parent project",
  "settings.projects.form.parentValue": "{name} ({code})",
  "settings.projects.form.noParent": "None (top-level project)",
  "settings.projects.form.parentEditDescription": "This project and its descendants are excluded from the options.",
  "settings.projects.form.parentCreateDescription": "Leave empty to create a top-level project.",
  "settings.projects.validation.codeRequired": "Enter a project code.",
  "settings.projects.validation.codeMax": "Project code cannot exceed {max} characters.",
  "settings.projects.validation.nameRequired": "Enter a project name.",
  "settings.projects.validation.nameMax": "Project name cannot exceed {max} characters.",
  "settings.projects.toast.created": "Project “{name}” was created",
  "settings.projects.toast.saved": "Project “{name}” was saved",
  "settings.projects.toast.enabled": "Project “{name}” was enabled",
  "settings.projects.toast.disabled": "Project “{name}” was disabled",
  "settings.projects.toast.deleted": "Project “{name}” was deleted",

  "settings.categories.title": "Ticket categories",
  "settings.categories.description": "Maintain categories by project and hierarchy so manual work, routing, and AI classification use the same structure.",
  "settings.categories.new": "New category",
  "settings.categories.create": "Create category",
  "settings.categories.delete": "Delete category",
  "settings.categories.refreshing": "Refreshing categories",
  "settings.categories.loading": "Loading ticket categories…",
  "settings.categories.saving": "Saving category",
  "settings.categories.deleting": "Deleting category",
  "settings.categories.searchAria": "Search ticket categories",
  "settings.categories.searchPlaceholder": "Search names or paths…",
  "settings.categories.metric.categories": "categories",
  "settings.categories.metric.global": "global categories",
  "settings.categories.metric.projects": "projects configured",
  "settings.categories.empty.title": "No ticket categories yet",
  "settings.categories.empty.description": "Create global categories or a project-specific category structure.",
  "settings.categories.empty.filtered": "No matching categories.",
  "settings.categories.scopeLabel": "Scope",
  "settings.categories.scope.all": "All scopes",
  "settings.categories.scope.global": "Available to all projects",
  "settings.categories.parentLabel": "Parent category",
  "settings.categories.childrenLabel": "Child categories",
  "settings.categories.projectUnavailable": "Project details are unavailable",
  "settings.categories.projectUnknown": "Unknown project",
  "settings.categories.projectDisabled": "{name} (disabled)",
  "settings.categories.addChild": "Add child",
  "settings.categories.editAria": "Edit {name}",
  "settings.categories.deleteAria": "Delete {name}",
  "settings.categories.deleteBlocked": "Move or delete child categories first",
  "settings.categories.noParentDetail": "None; this is a top-level category",
  "settings.categories.childrenCount": "{count}, expanded on the left",
  "settings.categories.noChildren": "No child categories",
  "settings.categories.deleteChildrenHint": "Move or delete this category's children before deleting it.",
  "settings.categories.selectHint": "Select a category on the left to view its details.",
  "settings.categories.expandAria": "Expand {name}",
  "settings.categories.collapseAria": "Collapse {name}",
  "settings.categories.deleteDialog.title": "Delete category “{name}”?",
  "settings.categories.deleteDialog.description": "This cannot be undone. If tickets or routing rules still reference this category, the system will reject the deletion until those configurations are updated.",
  "settings.categories.form.editTitle": "Edit category",
  "settings.categories.form.createTitle": "New category",
  "settings.categories.form.description": "Set the category's project scope and hierarchy. The full path is maintained automatically.",
  "settings.categories.form.nameLabel": "Category name",
  "settings.categories.form.namePlaceholder": "For example, Refund status",
  "settings.categories.form.currentProjectUnavailable": "Current project (details unavailable)",
  "settings.categories.form.scopeDescription": "Global categories are available to every project; project categories appear only in their project.",
  "settings.categories.form.noParent": "No parent; make this a top-level category",
  "settings.categories.defaultPriorityLabel": "Default priority",
  "settings.categories.form.inheritPriority": "Inherit from parent",
  "settings.categories.form.defaultPriorityDescription": "Used only for new tickets with no explicitly selected priority. Existing tickets are unaffected.",
  "settings.categories.form.inheritedPriority": "Current inherited priority: {priority}.",
  "settings.categories.form.globalPriority": "Top-level categories inherit the global default: {priority}.",
  "settings.categories.inheritedPriorityDetail": "Inherit from parent ({priority})",
  "settings.categories.globalPriorityDetail": "Global default ({priority})",
  "settings.categories.table.name": "Category",
  "settings.categories.table.scope": "Scope",
  "settings.categories.table.defaultPriority": "Default priority",
  "settings.categories.table.actions": "Actions",
  "settings.categories.addChildAria": "Add child category to {name}",
  "settings.categories.table.childrenCount": "{count} child categories",
  "settings.categories.searchExpandedHint": "Ancestors of matching categories are expanded while searching.",
  "settings.categories.form.moveDescendants": "Changing the scope or parent will move {count} child categories with this category.",
  "settings.categories.validation.nameRequired": "Enter a category name.",
  "settings.categories.validation.nameMax": "Name cannot exceed {max} characters.",
  "settings.categories.toast.created": "Category “{name}” was created",
  "settings.categories.toast.saved": "Category “{name}” was saved",
  "settings.categories.toast.deleted": "Category “{name}” was deleted",

  "settings.routing.title": "Routing rules",
  "settings.routing.description": "Match new tickets by priority and assign them to support teams. Lower numbers run first, and processing stops after the first match.",
  "settings.routing.new": "New rule",
  "settings.routing.create": "Create rule",
  "settings.routing.delete": "Delete rule",
  "settings.routing.refreshing": "Refreshing routing rules",
  "settings.routing.loading": "Loading routing rules…",
  "settings.routing.saving": "Saving rule",
  "settings.routing.deleting": "Deleting rule",
  "settings.routing.searchAria": "Search routing rules",
  "settings.routing.searchPlaceholder": "Search criteria or support teams…",
  "settings.routing.metric.rules": "rules",
  "settings.routing.metric.enabled": "enabled",
  "settings.routing.metric.fallback": "fallback rules",
  "settings.routing.empty.title": "No routing rules yet",
  "settings.routing.empty.description": "Create a rule to automatically send matching new tickets to a support team.",
  "settings.routing.empty.filtered": "No matching rules.",
  "settings.routing.visibleCount": "Showing {count} · Runs from lowest to highest priority",
  "settings.routing.column.priority": "Priority",
  "settings.routing.column.criteria": "Match criteria",
  "settings.routing.column.assignment": "Assign to",
  "settings.routing.project.all": "All projects",
  "settings.routing.project.unscoped": "No project restriction",
  "settings.routing.project.any": "Any project",
  "settings.routing.project.unknown": "Unknown project",
  "settings.routing.category.any": "Any category",
  "settings.routing.category.unknown": "Unknown category",
  "settings.routing.channel.any": "Any channel",
  "settings.routing.channel.unknown": "Unknown channel",
  "settings.routing.channel.web": "Web",
  "settings.routing.channel.phone": "Phone",
  "settings.routing.channel.api": "API",
  "settings.routing.team.unknown": "Unknown support team",
  "settings.routing.criteria.whenProject": "When project is",
  "settings.routing.criteria.whenCategory": "When category is",
  "settings.routing.criteria.whenChannel": "When channel is",
  "settings.routing.criteria.andMatches": "And matches",
  "settings.routing.criteria.advanced": "Advanced criteria",
  "settings.routing.criteria.allNewTickets": "All new tickets",
  "settings.routing.warning.teamMissing": "The target support team does not exist",
  "settings.routing.warning.teamDisabled": "The target support team is disabled, so this rule will be skipped",
  "settings.routing.warning.scopeMismatch": "The target team's scope does not match the rule's project",
  "settings.routing.warning.advanced": "Contains advanced criteria; verify the backend matcher",
  "settings.routing.editAria": "Edit rule",
  "settings.routing.deleteAria": "Delete rule",
  "settings.routing.deleteDialog.title": "Delete the priority {priority} rule?",
  "settings.routing.deleteDialog.description": "This cannot be undone. New tickets will no longer pass through this routing rule.",
  "settings.routing.form.editTitle": "Edit routing rule",
  "settings.routing.form.createTitle": "New routing rule",
  "settings.routing.form.description": "Tickets must match every selected condition. Rules run from lowest to highest priority and stop after the first match.",
  "settings.routing.form.criteriaTitle": "Match criteria",
  "settings.routing.form.criteriaDescription": "An empty condition does not restrict that dimension.",
  "settings.routing.form.channelLabel": "Source channel",
  "settings.routing.form.priorityDescription": "Lower numbers run first. Use 10, 20, and 30 to leave room for rules added later.",
  "settings.routing.form.resultTitle": "Assignment result",
  "settings.routing.form.resultDescription": "Project teams can receive tickets only for their project; functional teams can work across projects.",
  "settings.routing.form.teamLabel": "Target support team",
  "settings.routing.form.teamPlaceholder": "Select a support team",
  "settings.routing.form.categoryProjectSuffix": " · {project}",
  "settings.routing.form.teamProjectSuffix": " · {project}",
  "settings.routing.form.teamFunctionalSuffix": " · Functional team",
  "settings.routing.form.disabledTeamDescription": "This support team is disabled, so the routing engine will skip the rule even if it is enabled.",
  "settings.routing.form.enableImmediately": "Enable immediately",
  "settings.routing.form.advancedTitle": "Advanced criteria (JSON)",
  "settings.routing.form.jsonLabel": "Criteria JSON",
  "settings.routing.form.jsonPlaceholder": "For example, {\"country\":\"ZM\"}",
  "settings.routing.form.jsonDescription": "An empty value or {} means no additional criteria.",
  "settings.routing.form.advancedWarning": "The basic matcher does not match non-empty advanced criteria. Verify that the corresponding backend matcher is installed.",
  "settings.routing.validation.priority": "Priority must be an integer greater than or equal to 0.",
  "settings.routing.validation.teamRequired": "Select the support team that should receive the ticket.",
  "settings.routing.validation.scopeMismatch": "This project team cannot receive tickets in the current rule scope.",
  "settings.routing.validation.json": "Enter valid JSON.",
  "settings.routing.toast.created": "The priority {priority} routing rule was created",
  "settings.routing.toast.saved": "The priority {priority} routing rule was saved",
  "settings.routing.toast.enabled": "The priority {priority} rule was enabled",
  "settings.routing.toast.disabled": "The priority {priority} rule was disabled",
  "settings.routing.toast.deleted": "The priority {priority} routing rule was deleted",

  "settings.organization.title": "Teams & agents",
  "settings.organization.description": "Manage support team scopes, staffing, and system member profiles and permissions in one workspace.",
  "settings.organization.identityUnavailable": "No user name",
  "settings.organization.assignmentPolicy.roundRobin.label": "Round robin",
  "settings.organization.assignmentPolicy.roundRobin.description": "Automatically assign tickets to team members in sequence.",
  "settings.organization.assignmentPolicy.manual.label": "Manual assignment",
  "settings.organization.assignmentPolicy.manual.description": "A team lead or administrator selects the owner.",
  "settings.organization.assignmentPolicy.claim.label": "Self assignment",
  "settings.organization.assignmentPolicy.claim.description": "Team members claim tickets after they enter the team.",
  "settings.organization.assignmentPolicy.unknown": "Unknown policy",
  "settings.organization.scope.functional.label": "Functional team",
  "settings.organization.scope.functional.description": "Handles a specific function across projects.",
  "settings.organization.scope.project.label": "Project team",
  "settings.organization.scope.project.description": "Serves one specific project.",
  "settings.organization.membershipRole.member": "Member",
  "settings.organization.membershipRole.lead": "Team lead",
  "settings.organization.role.unknown": "Unknown role",
  "settings.organization.globalRole.admin.label": "Administrator",
  "settings.organization.globalRole.admin.description": "Manage system settings, tickets, teams, and agents.",
  "settings.organization.globalRole.viewer.label": "Report viewer",
  "settings.organization.globalRole.viewer.description": "View dashboards and reports without handling tickets.",
  "settings.organization.globalRole.scopeAll.label": "View all tickets",
  "settings.organization.globalRole.scopeAll.description": "View tickets from every support team without management permissions.",

  "settings.teams.title": "Support teams",
  "settings.teams.description": "Organize frontline support and define each team's project scope, assignment policy, and responsibilities.",
  "settings.teams.new": "New support team",
  "settings.teams.create": "Create support team",
  "settings.teams.delete": "Delete support team",
  "settings.teams.refreshing": "Refreshing support teams",
  "settings.teams.loading": "Loading support teams…",
  "settings.teams.saving": "Saving support team",
  "settings.teams.searchAria": "Search support teams",
  "settings.teams.searchPlaceholder": "Search support teams…",
  "settings.teams.metric.teams": "support teams",
  "settings.teams.metric.active": "running",
  "settings.teams.metric.members": "assigned members",
  "settings.teams.status.running": "Running",
  "settings.teams.scope.all": "All scopes",
  "settings.teams.scope.crossProjectFunctional": "Cross-project functional team",
  "settings.teams.scope.projectMissing": "Project scope not found",
  "settings.teams.scope.disabledProject": "{name} (project disabled)",
  "settings.teams.memberCount": "{count} members",
  "settings.teams.empty.title": "No support teams yet",
  "settings.teams.empty.description": "Create a support team, then add people who have already been provisioned in the system.",
  "settings.teams.empty.filtered": "No matching support teams.",
  "settings.teams.teamDisabled": "Team disabled",
  "settings.teams.deleteAria": "Delete {name}",
  "settings.teams.membersTitle": "Team members",
  "settings.teams.membersDescription": "Team leads can assign tickets and manage participants; members handle day-to-day work.",
  "settings.teams.addMember": "Add member",
  "settings.teams.memberUnknown": "Unknown member",
  "settings.teams.memberProfileUnavailable": "Member details are unavailable",
  "settings.teams.updatingMemberRole": "Updating {name}'s role",
  "settings.teams.removeMemberAria": "Remove {name}",
  "settings.teams.removingMember": "Removing member",
  "settings.teams.membersEmpty.title": "This support team has no members yet",
  "settings.teams.membersEmpty.description": "After adding members, their team roles immediately participate in permission calculations.",
  "settings.teams.deleteDialog.title": "Delete support team “{name}”?",
  "settings.teams.deleteDialog.description": "Members will not be deleted, but all team roles will be removed. If you only want to stop new tickets, disable the team instead.",
  "settings.teams.form.editTitle": "Edit support team",
  "settings.teams.form.createTitle": "New support team",
  "settings.teams.form.description": "Define the team's service scope and how new tickets are assigned.",
  "settings.teams.form.nameLabel": "Support team name",
  "settings.teams.form.namePlaceholder": "For example, Payments Support",
  "settings.teams.form.scopeLabel": "Service scope",
  "settings.teams.form.projectLabel": "Project",
  "settings.teams.form.projectPlaceholder": "Select a project",
  "settings.teams.form.assignmentPolicyLabel": "Assignment policy",
  "settings.teams.validation.nameRequired": "Enter a support team name.",
  "settings.teams.validation.nameMax": "Name cannot exceed {max} characters.",
  "settings.teams.validation.projectRequired": "Select the project served by this team.",
  "settings.teams.memberPicker.title": "Add team member",
  "settings.teams.memberPicker.description": "Select a system member to add to “{team}”. To add a new person, provision them from IAM on the Agents tab first.",
  "settings.teams.memberPicker.roleLabel": "Role after joining",
  "settings.teams.memberPicker.roleDescription": "You can change it later in the team member list.",
  "settings.teams.memberPicker.searchAria": "Search system members",
  "settings.teams.memberPicker.searchPlaceholder": "Search names, email addresses, or skills…",
  "settings.teams.memberPicker.loading": "Loading system members…",
  "settings.teams.memberPicker.errorTitle": "Unable to load system members",
  "settings.teams.memberPicker.errorDescription": "Check your network and try again.",
  "settings.teams.memberPicker.adding": "Adding system member",
  "settings.teams.memberPicker.alreadyAdded": "Already in team",
  "settings.teams.memberPicker.noMatches": "No matching system members.",
  "settings.teams.memberPicker.noAgents": "There are no system members yet. Provision someone on the Agents tab first.",
  "settings.teams.toast.created": "Support team “{name}” was created",
  "settings.teams.toast.saved": "Support team “{name}” was saved",
  "settings.teams.toast.enabled": "Support team “{name}” was enabled",
  "settings.teams.toast.disabled": "Support team “{name}” was disabled",
  "settings.teams.toast.deleted": "Support team “{name}” was deleted",
  "settings.teams.toast.memberAdded": "{name} joined “{team}”",
  "settings.teams.toast.memberRoleUpdated": "{name}'s team role was updated",
  "settings.teams.toast.memberRemoved": "{name} was removed from “{team}”",

  "settings.agents.title": "Agents",
  "settings.agents.description": "Manage provisioned agents' support profiles, access status, and global permissions. Names, email addresses, and avatars always come from IAM.",
  "settings.agents.provisionFromIam": "Provision agent from IAM",
  "settings.agents.provisionFromIamShort": "Provision from IAM",
  "settings.agents.refreshing": "Refreshing agents",
  "settings.agents.loading": "Loading agents…",
  "settings.agents.updatingStatus": "Updating agent status",
  "settings.agents.metric.provisioned": "provisioned agents",
  "settings.agents.metric.active": "able to sign in",
  "settings.agents.metric.unassigned": "not assigned to a team",
  "settings.agents.empty.title": "No provisioned agents yet",
  "settings.agents.empty.description": "Provision people from the IAM employee directory, then assign them to support teams or global roles.",
  "settings.agents.empty.filtered": "No matching agents.",
  "settings.agents.searchAria": "Search agents",
  "settings.agents.searchPlaceholder": "Name, email address, or skill…",
  "settings.agents.status.canSignIn": "Can sign in",
  "settings.agents.status.workspaceAccess": "Can access the workspace",
  "settings.agents.status.noWorkspaceAccess": "Disabled and cannot sign in",
  "settings.agents.roleFilter.all": "All global roles",
  "settings.agents.roleFilter.none": "No global role",
  "settings.agents.currentAccount": "Current account",
  "settings.agents.editProfile": "Edit profile",
  "settings.agents.admissionStatus": "Access status",
  "settings.agents.skills": "Skills",
  "settings.agents.skillsEmpty": "No skill tags have been added",
  "settings.agents.globalRoles": "Global roles",
  "settings.agents.globalRolesDescription": "Global roles are not limited by support team scope. Manage team permissions on the Support teams page.",
  "settings.agents.grantRoleAria": "Grant {role}",
  "settings.agents.revokeRoleAria": "Revoke {role}",
  "settings.agents.roleGranted": "Granted",
  "settings.agents.roleNotGranted": "Not granted",
  "settings.agents.teamMemberships": "Support team memberships",
  "settings.agents.teamMembershipsDescription": "Team roles apply only to tickets within the corresponding support team's scope.",
  "settings.agents.noTeamMemberships": "Not a member of any support team.",
  "settings.agents.deactivateDialog.title": "Disable agent “{name}”?",
  "settings.agents.deactivateDialog.description": "The agent will immediately lose workspace access, while historical tickets, team memberships, and role records remain available.",
  "settings.agents.deactivateDialog.selfWarning": " This is your current account. If you continue, you will lose access to the workspace.",
  "settings.agents.deactivateDialog.confirm": "Disable agent",
  "settings.agents.profile.title": "Edit support profile",
  "settings.agents.profile.description": "{name}'s name, email address, and avatar come from IAM. Only Tickbird support attributes are managed here.",
  "settings.agents.profile.extensionLabel": "Contact center extension",
  "settings.agents.profile.extensionPlaceholder": "For example, 8021",
  "settings.agents.profile.skillsLabel": "Skill tags",
  "settings.agents.profile.skillsPlaceholder": "Payments, refunds, English support",
  "settings.agents.profile.skillsDescription": "Separate entries with commas or new lines. Duplicate entries are merged automatically.",
  "settings.agents.profile.save": "Save profile",
  "settings.agents.profile.saving": "Saving profile",
  "settings.agents.profile.validation.extensionMax": "Extension cannot exceed {max} characters.",
  "settings.agents.iam.searchAria": "Search the IAM employee directory",
  "settings.agents.iamSubjectLabel": "IAM subject",
  "settings.agents.iam.searchPlaceholder": "Enter a name or email address…",
  "settings.agents.iam.searchHint": "Enter a keyword to find someone in the company employee directory.",
  "settings.agents.iam.searching": "Searching the employee directory…",
  "settings.agents.iam.errorTitle": "The employee directory is unavailable",
  "settings.agents.iam.errorDescription": "Try again later. Identity subjects cannot be entered manually.",
  "settings.agents.iam.noMatches": "No matching employees. Try another keyword.",
  "settings.agents.iam.adding": "Adding employee",
  "settings.agents.iam.provision": "Provision",
  "settings.agents.iam.provisioned": "Provisioned",
  "settings.agents.iam.provisionedDisabled": "Provisioned · Disabled",
  "settings.agents.iam.provisionDescription": "Only the IAM identity is submitted. The server reads names, email addresses, and avatars from the employee directory. Assign a support team or global role after provisioning.",
  "settings.agents.toast.provisioned": "{name} was provisioned",
  "settings.agents.toast.profileSaved": "{name}'s support profile was saved",
  "settings.agents.toast.enabled": "{name} was enabled",
  "settings.agents.toast.disabled": "{name} was disabled",
  "settings.agents.toast.roleGranted": "{name} was granted “{role}”",
  "settings.agents.toast.roleRevoked": "“{role}” was revoked from {name}",

  "settings.ai.title": "AI",
  "settings.ai.description": "Configure automatic ticket classification, reply suggestions, summaries, and model parameters.",
  "settings.ai.navigation.general": "General settings",
  "settings.ai.navigation.providers": "AI providers",
  "settings.ai.navigation.loadError": "Unable to load the provider list.",
  "settings.ai.navigation.empty": "No configurable AI providers are available.",
  "settings.ai.navigation.loading": "Loading AI providers",
  "settings.ai.status.enabled": "Enabled",
  "settings.ai.status.configured": "Configured",
  "settings.ai.status.configuredDisabled": "Configured · Disabled",
  "settings.ai.status.notConfigured": "Not configured",
  "settings.ai.loading": "Loading AI settings",
  "settings.ai.automation.toastSaved": "AI general settings were saved",
  "settings.ai.automation.validation.confidence": "Enter an integer from 0 to 100.",
  "settings.ai.automation.title": "General settings",
  "settings.ai.automation.description": "Control global adoption rules for AI automation.",
  "settings.ai.automation.classificationTitle": "Automatically apply classification suggestions",
  "settings.ai.automation.classificationDescription": "When an AI classification suggestion reaches the configured confidence, the system can apply it automatically. Lower-confidence results still require human confirmation.",
  "settings.ai.automation.confidenceLabel": "Minimum confidence",
  "settings.ai.automation.confidenceDescription": "Start at 80% and adjust gradually based on observed accuracy.",
  "settings.ai.automation.confidenceSliderAria": "Minimum confidence slider",
  "settings.ai.automation.alwaysManual": "Always require human confirmation",
  "settings.ai.automation.highConfidenceOnly": "Automatically apply only high-confidence results",
  "settings.ai.automation.modelHint": "Select a specific AI provider on the left to configure the models used for classification, summaries, next-action suggestions, and reply drafts.",
  "settings.ai.cancelChanges": "Discard changes",
  "settings.ai.saveSettings": "Save settings",
  "settings.ai.saving": "Saving…",
  "settings.ai.automation.saving": "Saving automation settings",
  "settings.ai.provider.toastSaved": "{name} settings were saved",
  "settings.ai.provider.viewDocs": "View documentation",
  "settings.ai.provider.capability.classification": "Ticket classification",
  "settings.ai.provider.capability.summary": "Summary",
  "settings.ai.provider.capability.nextAction": "Next-action suggestions",
  "settings.ai.provider.capability.replyDraft": "Reply drafts",
  "settings.ai.provider.configurationRequiredTitle": "Complete the required configuration before enabling",
  "settings.ai.provider.configurationRequiredDescription": "Enter an API key and default model before turning on Enable.",
  "settings.ai.provider.changedOnlyHint": "Only changed fields are saved. Secrets are never displayed.",
  "settings.ai.provider.saving": "Saving AI settings",
  "settings.ai.provider.customValue": "Custom value",
  "settings.ai.provider.resetPending": "Restore default after saving",
  "settings.ai.provider.restoreDeploymentDefault": "Restore deployment default",
  "settings.ai.provider.selectPlaceholder": "Select an option",
  "settings.ai.provider.secretConfiguredPlaceholder": "Configured; enter a new value to replace it",
  "settings.ai.provider.secretPlaceholder": "Enter secret",
  "settings.ai.provider.hideSecretAria": "Hide secret",
  "settings.ai.provider.showSecretAria": "Show secret",
  "settings.ai.provider.modelPlaceholder": "Enter a model ID or select from the list",
  "settings.ai.provider.refreshModelsAria": "Refresh model list",
  "settings.ai.provider.refreshingModels": "Refreshing model list",
  "settings.ai.provider.modelsError": "The model list is temporarily unavailable. You can still enter a model ID manually.",
  "settings.ai.provider.saved": "Saved",
  "settings.ai.provider.restoreDefault": "Restore default",
  "settings.ai.provider.resetDescription": "Saving will clear the global override and restore the deployment configuration or code default.",
  "settings.ai.provider.validation.required": "Enter {label}.",
  "settings.ai.provider.validation.clearViaReset": "Use Restore default to clear this value.",
  "settings.ai.provider.validation.https": "Enter a complete URL that starts with https://.",
  "settings.ai.provider.validation.number": "Enter a valid number.",
  "settings.ai.provider.validation.min": "Must be at least {min}.",
  "settings.ai.provider.validation.max": "Must be no more than {max}.",

  "settings.system.title": "System settings",
  "settings.system.description": "Adjust workspace-wide general settings.",
  "settings.placeholder.notFoundTitle": "Page not found",
  "settings.placeholder.notFoundDescription": "This system configuration page does not exist. Use the navigation on the left to continue.",
  "settings.placeholder.contentTitle": "{title} content",
  "settings.placeholder.frameworkOnly": "Only the system configuration framework is available at this stage."
}
